import { DOC_FLOW_MAPPING_RESULT_ENTITY } from '../../../../constants/entity'
import { PageLoader } from '../../../Page'
import {
  useDocFlowMappingContext,
  useDocFlowMappingResultTable,
} from '../../DocFlow.hooks'
import { getDocFlowIsHiddenTableControlBarText } from '../../DocFlow.utils'
import { DocFlowPhaseTable } from '../../DocFlowPhaseTable'
import { DocFlowMappingResultTableFilterBar } from '../DocFlowMappingResultTableFilterBar'
import { DocFlowMappingResultTableRow } from '../DocFlowMappingResultTableRow'

import { updateDocFlowMappingResultTableConfig } from './DocFlowMappingResultTable.api'
import { DOC_FLOW_MAPPING_RESULT_TABLE_SKELETON_ROWS } from './DocFlowMappingResultTable.constants'
import {
  getDocFlowMapppingResultFilterApi,
  getDocFlowMapppingResultMassActions,
  getDocFlowMapppingResultTableItemActions,
} from './DocFlowMappingResultTable.utils'

import * as styles from './DocFlowMappingResultTable.module.css'

function DocFlowMappingResultTable() {
  const { loadingFileBytes } = useDocFlowMappingContext()

  const {
    actionLoading,
    selectionData,
    setItemAction,
    setMassAction,
    tableData,
  } = useDocFlowMappingResultTable()

  const { isRefetching } = tableData

  return (
    <>
      {isRefetching || actionLoading ? <PageLoader /> : null}
      <DocFlowPhaseTable
        TableFilterBar={DocFlowMappingResultTableFilterBar}
        TableRow={DocFlowMappingResultTableRow}
        entity={DOC_FLOW_MAPPING_RESULT_ENTITY}
        getActions={getDocFlowMapppingResultTableItemActions}
        getFilterApi={getDocFlowMapppingResultFilterApi}
        getIsHiddenTableText={getDocFlowIsHiddenTableControlBarText}
        getMassActions={getDocFlowMapppingResultMassActions}
        loadingTable={loadingFileBytes}
        paginationClassName={styles.pagination}
        selectionData={selectionData}
        setItemAction={setItemAction}
        setMassAction={setMassAction}
        tableLoader={tableData}
        tableProps={{
          skeletonRows: DOC_FLOW_MAPPING_RESULT_TABLE_SKELETON_ROWS,
        }}
        updateTableConfig={updateDocFlowMappingResultTableConfig}
      />
    </>
  )
}

export default DocFlowMappingResultTable
